"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/counterSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type CounterSection63sItem = {
    key: Key | null | undefined;
    /** Detected variants: "%" | "+" */
    h30Text: ReactNode;
    /** Detected variants: "Client" | "Expert" | "Healing" | "Personalized" */
    p0Text: ReactNode;
    /** Detected variants: "Satisfaction" | "Practitioners" | "Modalities" | "Plans" */
    span0Text: ReactNode;
    /** Detected variants: "col-sm-6 col-xl-3" */
    className?: string;
    /** Detected variants: "counter-item-seventeen" */
    div0ClassName?: string;
    /** Detected variants: "count" */
    h30ClassName?: string;
    /** Detected variants: "count-digit counter-loaded" */
    span0ClassName?: string;
    /** Detected variants: "counts[0]" | "counts[1]" | "counts[2]" | "counts[3]" */
    div0h30span0Expr0: ReactNode;
};
export type HomeSeventeenCounterSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: CounterSection63sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Every Number Holds a Story" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "We identify and address root causes through a comprehensive mind-body-spirit approach." */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    counterSection63s: CounterSection63sItem[];
    counterSection63sItemWrapper?: (item: CounterSection63sItem, content: ReactNode) => ReactNode;
    counterSection63sRenderer?: (defaultNode: ReactNode) => ReactNode;
    counterSection63sH3Visible?: boolean;
    counterSection63sH3Renderer?: (item: CounterSection63sItem, defaultNode: ReactNode) => ReactNode;
    counterSection63sH3Props?: Partial<ComponentProps<"h3">> | ((item: CounterSection63sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSeventeenCounterSectionGenerated: FC<HomeSeventeenCounterSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Every Number Holds a Story",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "We identify and address root causes through a comprehensive mind-body-spirit approach.",
    divDiv0H30H3Props,
    sectionDiv0Div1ClassName,
    counterSection63s,
    counterSection63sItemWrapper,
    counterSection63sRenderer,
    counterSection63sH3Visible,
    counterSection63sH3Renderer,
    counterSection63sH3Props,
}) => {
    return (
        <section className="counter-section-seventeen section pb-0">
            <div className="container">
                <div className="section-header section-header-seventeen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title text-gradient" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4 counts"}>
                    {renderCollectionNode(
                        counterSection63s,
                        (item: CounterSection63sItem) => (
                            <div className={item.className ?? "col-sm-6 col-xl-3"} key={item.key}>
                                <div className={item.div0ClassName ?? "counter-item-seventeen"}>
                                    {renderItemNode(counterSection63sH3Visible, counterSection63sH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "count"} {...(typeof counterSection63sH3Props === "function" ? counterSection63sH3Props(item) : (counterSection63sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>
                                            <span className={item.span0ClassName ?? "count-digit counter-loaded"}></span>
                                            {item.h30Text}
                                        </h3>
                                    ))}
                                    <p>
                                        {item.p0Text}
                                        <span>{item.span0Text}</span>
                                    </p>
                                </div>
                            </div>
                        ),
                        counterSection63sItemWrapper,
                        counterSection63sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeSeventeenCounterSectionGenerated;
